import { useEffect, useRef, useState } from "react";
import { Box, Card, CardMedia, IconButton, Slider } from "@mui/material";
import { ContentCut, Edit, Pause, PlayArrow } from "@mui/icons-material";

import AppIcon from "@/assets/app-icon.svg";
import TimeRow from "@/components/TimeRow";
import { uploadImage } from "@/services/upload";
import { useCurrentUser } from "@/services/hooks";

export default function MusicCard({ file, meta, setMeta, setTrimming }) {
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const { data: currentUser } = useCurrentUser();
  const [audioUrl, setAudioUrl] = useState("");

  const audioPostRef = useRef(null);

  const handlePlayPause = () => {
    if (audioPostRef.current.paused) {
      audioPostRef.current.play();
      setIsPlaying(true);
    } else {
      audioPostRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioPostRef.current) {
      setMeta((prev) => ({ ...prev, duration: audioPostRef.current.duration }));
    }
  };

  const handleTimeUpdate = () => {
    if (audioPostRef.current) {
      setCurrentTime(audioPostRef.current.currentTime);
    }
  };

  useEffect(() => {
    if (!file) return;
    // Revoke previous URL if any
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
    setAudioUrl(URL.createObjectURL(file));
  }, [file]);

  const handleCoverChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = await uploadImage(file);
    setMeta((prev) => ({ ...prev, cover: url }));
  };

  return (
    <Card
      style={{
        borderRadius: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        id="cover-photo"
        sx={{ position: "relative", width: 150, height: 150 }}
      >
        <CardMedia
          component="img"
          sx={{ width: 150, height: 150 }}
          image={meta.cover ? meta.cover : currentUser.meta.artwork || AppIcon}
        />
        <input
          accept="image/*"
          style={{ display: "none" }}
          id="cover-photo-input"
          type="file"
          onChange={handleCoverChange}
        />
        <IconButton
          sx={{
            position: "absolute",
            bottom: 15,
            left: 8,
            // opacity: 0.8,
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
          onClick={() => document.getElementById("cover-photo-input").click()}
        >
          <Edit />
        </IconButton>
      </Box>
      <Box sx={{ width: "100%", px: 3 }}>
        <audio
          ref={audioPostRef}
          src={audioUrl}
          controls
          onLoadedMetadata={handleLoadedMetadata}
          onTimeUpdate={handleTimeUpdate}
          style={{ display: "none" }}
        />
        <Box>
          <Slider
            id="current-time-slider"
            value={currentTime}
            color="secondary"
            onChange={(e, newValue) => {
              if (audioPostRef.current) {
                audioPostRef.current.currentTime = newValue;
              }
            }}
            max={meta.duration}
          />
          <TimeRow currentTime={currentTime} duration={meta.duration} />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <IconButton onClick={() => setTrimming(true)}>
              <ContentCut color="info" />
            </IconButton>
            <IconButton onClick={handlePlayPause} sx={{ p: 0 }}>
              {isPlaying ? (
                <Pause style={{ fontSize: "50px" }} />
              ) : (
                <PlayArrow style={{ fontSize: "50px" }} />
              )}
            </IconButton>
            <Box sx={{ width: "40px" }} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
